export default "__VITE_ASSET__B2ViYw$2__"